import { render, staticRenderFns } from "./adminMenuAuthoriz.vue?vue&type=template&id=714ec78e&scoped=true"
import script from "./adminMenuAuthoriz.vue?vue&type=script&lang=js"
export * from "./adminMenuAuthoriz.vue?vue&type=script&lang=js"
import style0 from "./adminMenuAuthoriz.vue?vue&type=style&index=0&id=714ec78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714ec78e",
  null
  
)

export default component.exports